import axios from 'axios';
import { CURRENT_HOST } from '../constant';

const BASE_URL = `https://${CURRENT_HOST}`;

const request = axios.create({
  baseURL: BASE_URL,
});

request.interceptors.response.use((resp) => {
  console.log(resp);
  return resp.data;
});

export default {
  get: (path, params) =>
    request.request({
      method: 'GET',
      url: path,
      params,
    }),
  post: (path, body) =>
    request.request({
      method: 'POST',
      url: path,
      data: body,
      headers: {
        'Content-Type': 'application/json',
      },
    }),
};
